// src/hooks/useSkus.js
import { useEffect, useState, useMemo } from "react";
import { collection, onSnapshot, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";

export default function useSkus() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "skuMaster"), orderBy("sku"));

    const unsub = onSnapshot(
      q,
      (snap) => {
        const rows = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setData(rows);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.error("useSkus error:", err);
        setError(err);
        setData([]);
        setLoading(false);
      }
    );

    return () => unsub();
  }, []);

  const options = useMemo(
    () =>
      data
        .filter((r) => r.sku)
        .map((r) => ({
          value: r.sku,
          label: r.sku,
        })),
    [data]
  );

  const map = useMemo(() => {
    const m = {};
    data.forEach((r) => {
      if (r.sku) m[r.sku] = r;
    });
    return m;
  }, [data]);

  return { data, options, map, loading, error };
}
